import { Link } from "react-router-dom";
import { Reveal } from "@/components/Reveal";
import { useProducts } from "@/lib/useProducts";
import { useSeo } from "@/lib/seo";
import { useLang, lp, loc } from "@/lib/i18n";

const T = {
  fr: {
    seoTitle: "Dames — les coups du jeu · Maison Partita",
    seoDesc: "Six eaux de parfum, un coup du jeu de dames chacune. Du premier coup au couronnement. Prochainement.",
    kicker: "Collection II — prochainement",
    title: "DAMES",
    intro: "Six eaux de parfum, six coups du jeu de dames. De l'ouverture au couronnement, chaque référence porte un geste du damier — et son pion encré sur le verre. Eau de parfum concentrée · 100 ml · Série limitée numérotée.",
    soon: "Prochainement",
    theRefs: "Les six coups",
    altEtui: (nom, coup) => `Flacon DAMES ${nom} — ${coup}`,
  },
  en: {
    seoTitle: "Dames — the moves of the game · Maison Partita",
    seoDesc: "Six eaux de parfum, each a move in the game of draughts. From the opening to the crowning. Coming soon.",
    kicker: "Collection II — coming soon",
    title: "DAMES",
    intro: "Six eaux de parfum, six moves in the game of draughts. From the opening to the crowning, each reference carries a gesture of the board — and its piece inked on the glass. Concentrated eau de parfum · 100 ml · Numbered limited series.",
    soon: "Coming soon",
    theRefs: "The six moves",
    altEtui: (nom, coup) => `DAMES ${nom} bottle — ${coup}`,
  },
};

export default function Dames() {
  const lang = useLang();
  const t = T[lang];
  useSeo(t.seoTitle, t.seoDesc);
  const { products } = useProducts("dames");

  return (
    <div>
      <section className="max-w-3xl mx-auto px-5 sm:px-10 pt-28 pb-20">
        <Reveal>
          <p className="text-[13px] tracking-[0.34em] uppercase text-zinc-500">{t.kicker}</p>
          <h1 className="mt-6 text-4xl sm:text-5xl lg:text-6xl tracking-[0.1em] uppercase text-zinc-50">{t.title}</h1>
          <p className="mt-10 text-[20px] leading-[1.8] text-zinc-300">{t.intro}</p>
        </Reveal>
      </section>

      <section className="max-w-[1400px] mx-auto px-5 sm:px-10 pb-32">
        <Reveal><p className="text-[13px] tracking-[0.34em] uppercase text-zinc-500 mb-16">{t.theRefs}</p></Reveal>
        <div className="grid gap-x-10 gap-y-20 sm:grid-cols-2 lg:grid-cols-3">
          {products.map((p, i) => (
            <Reveal key={p.id} delay={(i % 3) * 0.12}>
              <Link to={lp(lang, `/dames/${p.slug}`)} data-testid={`dames-${p.slug}`} className="group block">
                <div className="overflow-hidden bg-zinc-900 border border-zinc-800">
                  <img src={p.photo} alt={t.altEtui(p.name, loc(p, lang, "coup"))}
                    width="928" height="1152" loading="lazy" decoding="async"
                    className="w-full h-auto transition-transform duration-[1400ms] ease-out group-hover:scale-[1.03]"
                    style={{ aspectRatio: "4/5", objectFit: "cover" }} />
                </div>
                <div className="mt-6">
                  <div className="flex items-baseline justify-between gap-3">
                    <h3 className="text-xl tracking-[0.2em] uppercase text-zinc-100">{p.name}</h3>
                  </div>
                  <p className="mt-1 text-zinc-500 tracking-[0.08em]">{p.coup}</p>
                  <p className="mt-2 text-[13px] tracking-[0.2em] uppercase text-zinc-600">{t.soon}</p>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
